module.exports = __webpack_public_path__ + "img/circleOrange3b.1f042059.svg";